import produce from "immer";

import {
   DO_LOGIN_ERROR,
   UPDATE_BROKER_SELECTED_COMPANY_SUCCESS,
   GET_ELOG_LIST_SUCCESS,
   GET_ELOG_LIST_FAIL,
   GET_HR_POLICY_NO_SUCCESS,
   GET_HR_POLICY_NO_FAIL,
   VALIDATE_VIEW_ANALYTICS_PERMISSION,
   VALIDATE_VIEW_PRE_SIGNED_ELOG_PERMISSION,
   LOGIN_BROKER_SUCCESS,
   LOGIN_HR_SUCCESS,
   UPDATE_USER_TOKEN_EXPIRED_ERROR,
   RE_LOGIN_BROKER_SUCCESS,
   RE_LOGIN_HR_SUCCESS,
   VALIDATE_ADD_PARTNER_HR_PERMISSION,
   VALIDATE_DOWNLOAD_CLAIMS_DATA_PERMISSION,
   VALIDATE_VIEW_HR_PARTNER_ACCOUNT_LIST_PERMISSION,
   VALIDATE_VIEW_ACCOUNT_LOGS_PERMISSION
} from "../actions";
import navigation from "../_nav";

const initialState = {
   user: null,
   navigation,
   selectedPolicyNo: null,
   selectedCompanyName: null,
   tokenHasExpired: false,
   allowOutpatient: null,
   allowInpatient: null,
};

const userReducer = produce((draft, action) => {
   // eslint-disable-next-line default-case
   switch (action.type) {
      case UPDATE_USER_TOKEN_EXPIRED_ERROR:
         draft.tokenHasExpired = true;
         return;
      case RE_LOGIN_BROKER_SUCCESS:
         draft.tokenHasExpired = false;
         draft.user = action.payload.user;
         return;
      case RE_LOGIN_HR_SUCCESS:
         draft.tokenHasExpired = false;
         draft.user = action.payload.user;
         draft.navigation.items[0].name = action.payload.user.companyName;
         draft.selectedCompanyName = action.payload.user.companyName;
         return;
      case LOGIN_BROKER_SUCCESS:
         draft.user = action.payload.user;
         return;
      case LOGIN_HR_SUCCESS:
         draft.user = action.payload.user;
         draft.navigation.items[0].name = action.payload.user.companyName;
         draft.selectedCompanyName = action.payload.user.companyName;
         return;
      case UPDATE_BROKER_SELECTED_COMPANY_SUCCESS:
         draft.navigation.items[0].name = action.payload.data.user.companyName;
         draft.navigation.items[0].policyNo = action.payload.data.user.policyNo;
         return;
      case GET_HR_POLICY_NO_SUCCESS:
         draft.selectedPolicyNo = action.payload.data.client ? action.payload.data.client.policyNo : null;
         draft.allowOutpatient = action.payload.data.client ? action.payload.data.client.featuresConfig.allowOutpatient : false;
         draft.allowInpatient = action.payload.data.client ? action.payload.data.client.featuresConfig.allowInpatient : false;
         return;
      case GET_HR_POLICY_NO_FAIL:
         draft.selectedPolicyNo = null;
         return;
      case GET_ELOG_LIST_SUCCESS:
         draft.navigation.items[3].badge.text = action.payload.pendingHRElogCount;
         return;
      case GET_ELOG_LIST_FAIL:
         draft.navigation.items[3].badge.text = "";
         return;
      case draft.navigation.items[4] && VALIDATE_VIEW_PRE_SIGNED_ELOG_PERMISSION:
         draft.navigation.items[4].class = action.payload.permissionViewPreSignedELOG ? "" : "hide";
         return;
      case VALIDATE_VIEW_ANALYTICS_PERMISSION:
         draft.navigation.items[6].class = action.payload.permissionViewAnalytics ? "" : "hide";
         return;
      case VALIDATE_ADD_PARTNER_HR_PERMISSION:
         draft.navigation.items[8].class = action.payload.permissionAddPartnerHR ? "" : "hide";
         return;
      case VALIDATE_DOWNLOAD_CLAIMS_DATA_PERMISSION:
         draft.navigation.items[7].class = action.payload.permissionDownloadClaimsData ? "" : "hide";
         return;
      case draft.navigation.items[9] && VALIDATE_VIEW_HR_PARTNER_ACCOUNT_LIST_PERMISSION:
         draft.navigation.items[9].class = action.payload.permissionViewHRPartnerAccountList ? "" : "hide";
         return;
      case VALIDATE_VIEW_ACCOUNT_LOGS_PERMISSION:
         draft.navigation.items[10].class = action.payload.permissionViewAccountLogs || action.payload.permissionMasterAdmin ? "" : "hide";
         return;
      case DO_LOGIN_ERROR:
         draft.user = null;
         return;
   }
}, initialState);

export default userReducer;
